import BillingRequest from "./BillingRequest";
import BillingOverviewListing from "./BillingOverviewListing";
import BillingListing from "./BillingListing";

const BillingDetails = props => {
  return (
    <div id="billing-listing" className="page">
      <section className="billing-listing-container">
        <BillingRequest onComplete={() => { }} />
        <BillingListing />
        <BillingOverviewListing />
      </section>
    </div>
  );
};

export default BillingDetails;
